const StorageNotHiredIcon = ({
  width=32, 
  height=32
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="#D32F2F"/>
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M20.3429 9.25005C20.1038 9.11198 19.798 9.19392 19.6599 9.43307L12.1599 22.4234C12.0218 22.6626 12.1038 22.9684 12.3429 23.1065C12.5821 23.2445 12.8879 23.1626 13.0259 22.9234L13.9997 21.2369V22.0001H15.333V20.6667H14.3289L15.333 18.9275V20.0001H16.6663V18.6667H15.4836L17.0232 16.0001H19.333V22.0001H21.333C22.0663 22.0001 22.6663 21.4001 22.6663 20.6667V13.5667C22.6663 13.0201 22.333 12.5334 21.8263 12.3267L19.6472 11.4551L20.5259 9.93307C20.664 9.69392 20.5821 9.38813 20.3429 9.25005Z" fill="#D32F2F"/>
      <path d="M17.7681 10.7034L16.493 10.1934C16.173 10.0667 15.8197 10.0667 15.4997 10.1934L10.1663 12.3267C9.66634 12.5334 9.33301 13.0267 9.33301 13.5667V20.6667C9.33301 21.4001 9.93301 22.0001 10.6663 22.0001H11.2459L12.6663 19.5398V16.0001H14.71L17.7681 10.7034Z" fill="#D32F2F"/>
      <path d="M17.9997 20.6667H16.6663V22.0001H17.9997V20.6667Z" fill="#D32F2F"/>
    </svg>
  )
}

export default StorageNotHiredIcon;
